<template>
  <div>
    <div v-if="(this.currentUser && this.currentUser.type == 'administrator')" class="container mainContent">
      <h2>User Management</h2>
      <div class="btn-group btn-group-justified" role="group">
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-default">Add User</button>
        </div>
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-default">Import Users</button>
        </div>
      </div>
      <br />
      <transition appear name="fade" mode="out-in">
        <table class="table table-condensed table-bordered table-striped">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>User Level</th>
              <th>Invite Sent</th>
              <th>Opened</th>
              <th>Accepted</th>
              <th class="text-center">Groups</th>
              <th class="text-center">-</th>
              <th class="text-center">-</th>
              <th class="text-right">Functions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user['.key']">
              <td>{{ user.surname }}, {{ user.forename }}</td>
              <td><a v-bind:href="'mailto:' + user.email">{{ user.email }}</a></td>
              <td>{{ user.type }}</td>
              <td>{{ user.entered | epochtoreal }}</td>
              <td>{{ user.emailopened | epochtoreal }}</td>
              <td>{{ user.inviteaccepted | epochtoreal }}</td>
              <td class="text-center"><span v-if="user.ai2016">ai16,</span><span v-if="user.scientificcommittee">sc,</span></td>
              <td></td>
              <td></td>
              <td class="text-right">
                <div class="btn-group btn-group-xs" role="group" aria-label="...">
                  <button type="button" class="btn btn-default">Edit User</button>
                  <button type="button" class="btn btn-default">Reset Password</button>
                  <button type="button" class="btn btn-default btn-danger">Delete User</button>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </transition>

    </div>
    <div v-else class="container mainContent">
      <h2>An error has occured</h2>
      <p>Sorry, but you're not authorised to view this page.</p>
    </div>
  </div>
</template>

<script>
  // global variables
  var regexEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  var regexURL = /(\?|\&)([^=]+)\=([^&]+)$/
  var blankUser = { name: null,
                    email: null,
                    type: null};

  import Vuex from 'vuex';
  import { mapState } from 'vuex'
  import VuexFire from 'vuexfire';
  import firebase from 'firebase';
  // end global variables

  // firebase initialisation
  var db = firebase.database();
  // end firebase initialisation


  // helper functions
  // end helper functions

  export default {
    name: "manageusers",
    computed: {
      ...mapState({
        // map e.g. this.authData to store.state.authData
        authData: 'authData',
        contacts: 'contacts',
        currentUser: 'currentUser',
        route: 'route',
        users: 'users',
      })
    },
    firebase: {
      users: db.ref('users').orderByChild("surname")
    },
    filters: {
      epochtoreal: function (value) {
        if (value) {
          return moment(value).format('YYYY/MM/DD-HH:mm');
        } else {
          return "-";
        }
      },
      yesno: function (value) {
        return value ? "Yes" : "No";
      },
      tick: function (value) {
        return value ? "<i class=\"fa fa-check\" aria-hidden=\"true\"></i>" : "No";
      }
    },
    data () {
      return {
        messageError: null,
        messageSuccess: null
      }
    },
    methods: {
      focusNextField: function (event) { // moves focus to next input field
        $(event.target).parent().next("div").find("input").focus();
      }
    }
  }
</script>



/** WEBPACK FOOTER **
 ** manageusers.vue?6736ac4d
 **/